// @ts-check
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import HForm from 'shared/containers/portal_layout/HForm';
import { reduxForm, FieldArray } from 'utils/reduxFormWrapper';
import FlashMessageActions from 'shared/actions/FlashMessageActions';
import api from 'utils/api';
import Errors from 'shared/components/Errors';
import FileAttachments from 'shared/components/Referrals/FileAttachments';
import buildFormDataFromNestedJSON from 'utils/buildFormDataFromNestedJSON';
import transformFileLists from 'utils/transformFileLists';
import SpinnerButton from 'shared/components/SpinnerButton';

class FileUploader extends Component {
  constructor(props, context) {
    super(props, context);
    this.uploadFiles = this.uploadFiles.bind(this);
  }

  uploadFiles(formValues) {
    // FIXME: This assumes we have a browser with FormData, which means IE10+

    // Handle FileList conversion for multiple-file file inputs
    const allFormValues = {
      ...formValues,
      fileAttachmentsAttributes: transformFileLists(formValues.fileAttachmentsAttributes),
    };

    const formData = buildFormDataFromNestedJSON(allFormValues, 'referral');

    return api
      .post(
        `${this.props.apiEndpoint}/referrals/${this.props.referralId}/file_attachments`,
        formData
      )
      .then(response => {
        this.props.handleSuccess();
        FlashMessageActions.flashSuccess({
          message: 'You have successfully uploaded file(s) for this referral',
        });
      });
  }

  render() {
    return (
      <FormifiedPresentationComponent
        form="fileUpload"
        onSubmit={this.uploadFiles}
        render={this.props.render || defaultRender}
        initialValues={{
          fileAttachmentsAttributes: [{}],
        }}
      />
    );
  }
}

FileUploader.propTypes = {
  apiEndpoint: PropTypes.string.isRequired,
  handleSuccess: PropTypes.func.isRequired,
  referralId: PropTypes.string.isRequired,
};

const PresentationComponent = ({ render, ...props }) => render(props);

const defaultRender = props => (
  <HForm onSubmit={props.handleSubmit}>
    <div className="modal-header">
      <h3>Upload Files</h3>
    </div>
    <div className="modal-body" style={{ width: '600px' }}>
      <Errors errors={props.error || []} />
      <div className="control-group new-booking-form-group">
        <label className="control-label">Attach File(s)</label>
        <div className="controls">
          <FieldArray name="fileAttachmentsAttributes" component={FileAttachments} />
        </div>
      </div>
    </div>
    <div className="modal-footer">
      <SpinnerButton type="submit" className="btn btn-primary" loading={props.submitting}>
        Upload
      </SpinnerButton>
    </div>
  </HForm>
);

PresentationComponent.displayName = 'PresentationComponent';

const FormifiedPresentationComponent = reduxForm({})(PresentationComponent);

export default FileUploader;
